<div class="panel" *ngIf="show === 'editor'">
    <div class="panel-header">
        <h1>Hide Editor's Choice</h1>
    </div>

    <ng-container *ngIf="!isLoadingEditorChoice">
        <mat-radio-group class="custom-edit-item radio-group" [(ngModel)]="isHideEditorChoice"
            (ngModelChange)="saveIsEditorChoice()">
            <mat-radio-button [value]="true"> Yes</mat-radio-button>
            <mat-radio-button [value]="false"> No</mat-radio-button>
        </mat-radio-group>
    </ng-container>
    <div class="m-t-3 relative" *ngIf="!isHideEditorChoice">
        <ig-field label="Editor's choice display text for Events"
            [disabled]="!toggles.manualEvents&&!toggles.eventByGeolocation" [(ngModel)]="editorChoiceForEvent"
            [formControl]="customEditorChoiceForm.get('editorChoiceForEvent')">
        </ig-field>
        <upgrade-button [show]="!toggles.manualEvents&&!toggles.eventByGeolocation"
            [css]="'upgrade-editor-text'"></upgrade-button>

        <!-- <div class="m-t-3">Position (only enable on side bar mode)</div> -->
    </div>
    <div class="m-t-3 relative" *ngIf="!isHideEditorChoice">
        <ig-field label="Editor's choice display text for Places" [disabled]="!toggles.placeCalendar"
            [(ngModel)]="editorChoiceForPlace" [formControl]="customEditorChoiceForm.get('editorChoiceForPlace')">
        </ig-field>
        <upgrade-button [show]="!toggles.placeCalendar" [css]="'upgrade-editor-text'"></upgrade-button>

        <!-- <div class="m-t-3">Position (only enable on side bar mode)</div> -->
    </div>
    <ig-button (trigger)="saveEditorChoice($event)" size="md" [isAsync]="true">Save
    </ig-button>
    <!-- <ig-spinner *ngIf="isLoadingEditorChoice"></ig-spinner> -->
</div>

<div class="flex" *ngIf="show === 'custom'">
    <div class="panel half-width m-r-1">
        <div class="panel-header">
            <h1 [class.text-disabled]="!toggles.eventByGeolocation&&!toggles.manualEvents">Custom Event Categories</h1>
            <p *ngIf="toggles.eventByGeolocation||toggles.manualEvents" class="m-b-4">
                To reorganize the order of your category menu, drag-and-drop the category title to the desired position
            </p>

            <upgrade-button [show]="!toggles.eventByGeolocation&&!toggles.manualEvents"
                [css]="'upgrade-custom'"></upgrade-button>
        </div>

        <div>
            <mat-radio-group [formControl]="customEventForm.get('isEventOn')" class="custom-edit-item radio-group"
                (change)="toggleCustomEvents()" [disabled]="!toggles.eventByGeolocation&&!toggles.manualEvents"
                [(ngModel)]="isTurnOnCustomEvent">
                <mat-radio-button [value]="true"> Turn on</mat-radio-button>
                <mat-radio-button [value]="false"> Turn off</mat-radio-button>
            </mat-radio-group>

            <div *ngIf="isTurnOnCustomEvent&&(toggles.eventByGeolocation||toggles.manualEvents)" class="m-t-3">
                <div #customEventRow *ngFor="let customEventCommand of customEventCommands; let i = index" draggable
                    [dragScope]="'customEvents'" [dragEnabled]="!isEditAnyCategory()" droppable
                    [dropScope]="'customEvents'" [dragData]="customEventCommand" (onDragOver)="dragEnter($event)"
                    (onDrop)="onItemDrop($event, i)">
                    <ig-accordion *ngIf="!isEditDisplayTitle[i]" id="custom-event" icon="edit"
                        (onIconClick)="editDisplayTitle(i)" title="{{ customEventCommand.btnText }}"
                        iconTooltip="Edit display title">
                        <div class="m-t-2">
                            <div>
                                <p>URL: </p>
                                <div *ngIf="version.event.version==='V3'" style="color: orangered">V3 custom events URL
                                    is different from V2, please be aware:</div>
                                <div *ngIf="customEventCommand._id">
                                    <span>URL: </span>
                                    <mat-icon url (click)="copyCustomEventsEmbedScript(customEventCommand._id)">
                                        content_copy
                                    </mat-icon>
                                    <div class="code-area">
                                        <pre>
                                            <code>{{getCustomEventEmbedScript(customEventCommand._id)}}</code>
                                        </pre>
                                    </div>
                                </div>
                            </div>
                            <span *ngIf="!customEventCommand._id">please save the changes to see the URL</span>
                        </div>

                        <p class="remove-btn add-new-tab" (click)="removeCustomEventBtn(customEventCommand._id)">
                            <mat-icon>delete</mat-icon>
                            Delete this button
                        </p>
                    </ig-accordion>

                    <div class="flex" *ngIf="isEditDisplayTitle[i]">
                        <ig-field label="Edit Display Text" [formControl]="customEventForm.get('btnText')" icon="edit"
                            [(ngModel)]="customEventCommand.btnText">
                        </ig-field>
                        <ig-button class="edit-region-name" size="md" [isAsync]="true"
                            (trigger)="updateCustomEventBtnName($event, customEventCommand, i)">
                            save
                        </ig-button>
                        <ig-button class="edit-region-name" size="md" color="cancel"
                            (trigger)="cancelEditCustomEventBtnName(i)">cancel
                        </ig-button>
                    </div>
                </div>
                <p class="add-new-tab" (click)="addNewAndSaveEvent()">
                    <mat-icon>add</mat-icon>
                    Add a new custom event button
                </p>
            </div>
        </div>
    </div>

    <div class="panel half-width m-l-1">
        <div class="panel-header">
            <h1 [class.text-disabled]="!toggles.placeCalendar">Create "Favorite Places" Categories</h1>

            <upgrade-button [show]="!toggles.placeCalendar" [css]="'upgrade-custom'"></upgrade-button>
        </div>

        <div>
            <mat-radio-group [formControl]="customEventForm.get('isPlaceOn')" class="custom-edit-item radio-group"
                (change)="toggleCustomPlaces()" [disabled]="!toggles.placeCalendar" [(ngModel)]="isTurnOnCustomPlace">
                <mat-radio-button [value]="true"> Turn on</mat-radio-button>
                <mat-radio-button [value]="false"> Turn off</mat-radio-button>
            </mat-radio-group>

            <div *ngIf="isTurnOnCustomPlace&&toggles.placeCalendar" class="m-t-3">
                <div *ngFor="let place of customPlaceCommands; let i = index">
                    <ig-accordion *ngIf="!isEditPlaceDisplayTitle[i]" id="custom-place" icon="edit"
                        (onIconClick)="editPlaceDisplayTitle(i)" title="{{ place.btnText }}"
                        iconTooltip="Edit display title">
                        <div class="m-t-2">
                            <div>
                                <span>URL: </span>
                                <mat-icon url *ngIf="place._id" (click)="copyEmbedScript(place._id,'url')">
                                    content_copy
                                </mat-icon>
                                <div class="code-area" *ngIf="place._id">
                                    <pre>
                                        <code>{{getCustomPlaceEmbedScript(place._id)}}</code>
                                    </pre>
                                </div>
                            </div>
                            <div style="margin-top: 10px;">
                                <span>Map view URL: </span>
                                <mat-icon url *ngIf="place._id" (click)="copyEmbedScript(place._id,'mapViewUrl')">
                                    content_copy
                                </mat-icon>
                                <div class="code-area" *ngIf="place._id">
                                    <pre>
                                        <code>{{getCustomPlaceMapViewEmbedScript(place._id)}}</code>
                                    </pre>
                                </div>
                            </div>
                            <div style="margin-top: 10px;">
                                <span>Json Feed: </span>
                                <mat-icon url *ngIf="place._id" (click)="copyJsonFeed(place._id)">
                                    content_copy
                                </mat-icon>
                                <div class="code-area" *ngIf="place._id">
                                    <pre>
                                        <code> 
                                            {{ apiAddress }}v2.0/{{ hubName }}/places?type={{place._id}}
                                        </code>
                                    </pre>
                                </div>
                            </div>

                            <span *ngIf="!place._id">please save the changes to see the URL</span>
                        </div>

                        <p class="remove-btn add-new-tab" (click)="removeCustomPlaceBtn(place._id)">
                            <mat-icon>delete</mat-icon>
                            Delete this button
                        </p>
                        <p class="remove-btn add-new-tab" (click)="transferPlaces(place)">
                            <mat-icon>help_outline</mat-icon>
                            Transfer places to custom place categories
                        </p>

                    </ig-accordion>
                    <div class="flex" *ngIf="isEditPlaceDisplayTitle[i]">
                        <ig-field label="Edit Display Text" [formControl]="customEventForm.get('placeBtnText')"
                            icon="edit" [(ngModel)]="place.btnText">
                        </ig-field>
                        <ig-button class="edit-region-name" size="md" [isAsync]="true"
                            (trigger)="updateCustomPlaceBtnName($event, place, i)">save
                        </ig-button>
                        <ig-button class="edit-region-name" size="md" color="cancel"
                            (trigger)="cancelEditCustomPlaceBtnName(i)">cancel
                        </ig-button>
                    </div>
                </div>
                <p class="add-new-tab" (click)="addNewAndSavePlace()">
                    <mat-icon>add</mat-icon>
                    Add a new custom place button
                </p>
            </div>
        </div>
    </div>
</div>

<div class="panel" *ngIf="show === 'promotion'">
    <div class="panel-header">
        <h1>Visitor Promotion Image</h1>
    </div>

    <div class="flex">
        <div class="m-r-1">
            <mat-radio-group class="radio-group" [(ngModel)]="visitorPromotionImage.isDisabled">
                <mat-radio-button [value]="false">
                    Turn On Promotion Image
                </mat-radio-button>
                <mat-radio-button [value]="true">
                    Turn Off Promotion Image
                </mat-radio-button>
            </mat-radio-group>

            <div class="m-t-3" *ngIf="!visitorPromotionImage.isDisabled">
                <ig-field label="Link" [(ngModel)]="visitorPromotionImage.link"
                    [formControl]="promotionForm.get('link')">
                </ig-field>

                <div class="m-t-3">Position (only enable on side bar mode)</div>
                <div class="group">
                    <mat-radio-group [formControl]="promotionForm.get('isTop')" class="radio-group"
                        [(ngModel)]="visitorPromotionImageCommand.isTop">
                        <mat-radio-button [value]="false"> Bottom</mat-radio-button>
                        <mat-radio-button [value]="true"> Top</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <ig-button (trigger)="savePromotion($event)" size="md" [isAsync]="true">Save
            </ig-button>
        </div>

        <div class="m-l-1 promotional" *ngIf="!visitorPromotionImage.isDisabled">
            <ig-image-selector [command]="selectImgFile"
                [selectedImageData]="visitorPromotionImage.image">
            </ig-image-selector>
        </div>
    </div>
</div>

<!--<div class="marketing">-->
<!--    <mat-tab-group>-->
<!--        <mat-tab>-->
<!--            <ng-template mat-tab-label>-->
<!--                <mat-icon>favorite</mat-icon>-->
<!--                Editor's Choice-->
<!--            </ng-template>-->
<!--            <div class="panel">-->
<!--                <div class="panel-header">-->
<!--                    <h1>Hide Editor's Choice</h1>-->
<!--                </div>-->

<!--                <ng-container *ngIf="!isLoadingEditorChoice">-->
<!--                    <mat-radio-group class="custom-edit-item radio-group"-->
<!--                                     [(ngModel)]="isHideEditorChoice"-->
<!--                                     (ngModelChange)="saveIsEditorChoice()">-->
<!--                        <mat-radio-button [value]="true">-->
<!--                            Yes-->
<!--                        </mat-radio-button>-->
<!--                        <mat-radio-button [value]="false">-->
<!--                            No-->
<!--                        </mat-radio-button>-->
<!--                    </mat-radio-group>-->
<!--                </ng-container>-->
<!--                <ig-spinner *ngIf="isLoadingEditorChoice"></ig-spinner>-->
<!--            </div>-->
<!--        </mat-tab>-->
<!--        <mat-tab>-->
<!--            <ng-template mat-tab-label>-->
<!--                <mat-icon>star</mat-icon>-->
<!--                Custom Categories-->
<!--            </ng-template>-->
<!--            <div class="flex">-->
<!--                <div class="panel half-width m-r-1">-->
<!--                    <div class="panel-header">-->
<!--                        <h1>Custom Event Categories</h1>-->
<!--                    </div>-->

<!--                    <div>-->
<!--                        <mat-radio-group [formControl]="customEventForm.get('isEventOn')"-->
<!--                                         class="custom-edit-item radio-group"-->
<!--                                         (change)="toggleCustomEvents()"-->
<!--                                         [(ngModel)]="isTurnOnCustomEvent">-->
<!--                            <mat-radio-button [value]="true">-->
<!--                                Turn on-->
<!--                            </mat-radio-button>-->
<!--                            <mat-radio-button [value]="false">-->
<!--                                Turn off-->
<!--                            </mat-radio-button>-->
<!--                        </mat-radio-group>-->

<!--                        <div *ngIf="isTurnOnCustomEvent" class="m-t-3">-->
<!--                            <div *ngFor="let customEventCommand of customEventCommands; let i = index">-->
<!--                                <ig-accordion *ngIf="!isEditDisplayTitle[i]" id="custom-event" icon="edit"-->
<!--                                              (onIconClick)="editDisplayTitle(i)"-->
<!--                                              title="{{customEventCommand.btnText}}" iconTooltip="Edit display title">-->
<!--                                    <div class="m-t-2">-->
<!--                                        <div>-->
<!--                                            <span>URL: </span>&nbsp;-->
<!--                                            <span *ngIf="customEventCommand._id">/{{hubName}}/custom-events/{{customEventCommand._id}}-->
<!--                                                <mat-icon url *ngIf="customEventCommand._id"-->
<!--                                                          matTooltip="E.g., htttps://imgoingcalendar.com/{{hubName}}/custom-events/{{customEventCommand._id}}">-->
<!--                                                    error_outline-->
<!--                                                </mat-icon>-->
<!--                                            </span>-->
<!--                                        </div>-->
<!--                                        <div>-->
<!--                                            <span>Json Feed: </span>&nbsp;-->
<!--                                            <span *ngIf="customEventCommand._id">{{apiAddress}}v2.0/{{hubName}}/events?type={{customEventCommand._id}}-->
<!--                                                <mat-icon url *ngIf="customEventCommand._id"-->
<!--                                                          matTooltip="You can get the event list data via this API">-->
<!--                                                    error_outline-->
<!--                                                </mat-icon>-->
<!--                                            </span>-->
<!--                                        </div>-->

<!--                                        <span *ngIf="!customEventCommand._id">please save the changes to see the URL</span>-->
<!--                                    </div>-->

<!--                                    <p class="remove-btn add-new-tab"-->
<!--                                       (click)="removeCustomEventBtn(customEventCommand._id)">-->
<!--                                        <mat-icon>delete</mat-icon>-->
<!--                                        Delete this button-->
<!--                                    </p>-->

<!--                                </ig-accordion>-->

<!--                                <div class="flex" *ngIf="isEditDisplayTitle[i]">-->
<!--                                    <ig-field label="Edit Display Text"-->
<!--                                              [formControl]="customEventForm.get('btnText')"-->
<!--                                              icon="edit"-->
<!--                                              [(ngModel)]="customEventCommand.btnText">-->
<!--                                    </ig-field>-->
<!--                                    <ig-button class="edit-region-name" size="md"-->
<!--                                               [isAsync]="true"-->
<!--                                               (trigger)="updateCustomEventBtnName($event, customEventCommand, i)">save-->
<!--                                    </ig-button>-->
<!--                                    <ig-button class="edit-region-name" size="md" color="cancel"-->
<!--                                               (trigger)="isEditDisplayTitle[i]=false">cancel-->
<!--                                    </ig-button>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <p class="add-new-tab" (click)="addNewAndSaveEvent()">-->
<!--                                <mat-icon>add</mat-icon>-->
<!--                                Add a new custom event button-->
<!--                            </p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="panel half-width m-l-1">-->
<!--                    <div class="panel-header">-->
<!--                        <h1>Custom Place Categories</h1>-->
<!--                    </div>-->

<!--                    <div>-->
<!--                        <mat-radio-group [formControl]="customEventForm.get('isPlaceOn')"-->
<!--                                         class="custom-edit-item radio-group"-->
<!--                                         (change)="toggleCustomPlaces()"-->
<!--                                         [(ngModel)]="isTurnOnCustomPlace">-->
<!--                            <mat-radio-button [value]="true">-->
<!--                                Turn on-->
<!--                            </mat-radio-button>-->
<!--                            <mat-radio-button [value]="false">-->
<!--                                Turn off-->
<!--                            </mat-radio-button>-->
<!--                        </mat-radio-group>-->

<!--                        <div *ngIf="isTurnOnCustomPlace" class="m-t-3">-->
<!--                            <div *ngFor="let place of customPlaceCommands; let i = index">-->
<!--                                <ig-accordion *ngIf="!isEditPlaceDisplayTitle[i]" id="custom-place" icon="edit"-->
<!--                                              (onIconClick)="editPlaceDisplayTitle(i)"-->
<!--                                              title="{{place.btnText}}" iconTooltip="Edit display title">-->
<!--                                    <div class="m-t-2">-->
<!--                                        <div>-->
<!--                                            <span>URL: </span>&nbsp;-->
<!--                                            <span *ngIf="place._id">/{{hubName}}/custom-places/{{place._id}}-->
<!--                                            <mat-icon url *ngIf="place._id"-->
<!--                                                      matTooltip="E.g., htttps://imgoingcalendar.com/{{hubName}}/custom-places/{{place._id}}">-->
<!--                                                error_outline-->
<!--                                            </mat-icon>-->
<!--                                        </span>-->
<!--                                        </div>-->
<!--                                        <div>-->
<!--                                            <span>Json Feed: </span>&nbsp;-->
<!--                                            <span *ngIf="place._id">{{apiAddress}}v2.0/{{hubName}}/places?type={{place._id}}-->
<!--                                                <mat-icon url *ngIf="place._id"-->
<!--                                                          matTooltip="You can get the place list data via this API">-->
<!--                                                    error_outline-->
<!--                                                </mat-icon>-->
<!--                                            </span>-->
<!--                                        </div>-->

<!--                                        <span *ngIf="!place._id">please save the changes to see the URL</span>-->
<!--                                    </div>-->

<!--                                    <p class="remove-btn add-new-tab"-->
<!--                                       (click)="removeCustomPlaceBtn(place._id)">-->
<!--                                        <mat-icon>delete</mat-icon>-->
<!--                                        Delete this button-->
<!--                                    </p>-->

<!--                                </ig-accordion>-->
<!--                                <div class="flex" *ngIf="isEditPlaceDisplayTitle[i]">-->
<!--                                    <ig-field label="Edit Display Text"-->
<!--                                              [formControl]="customEventForm.get('placeBtnText')"-->
<!--                                              icon="edit"-->
<!--                                              [(ngModel)]="place.btnText">-->
<!--                                    </ig-field>-->
<!--                                    <ig-button class="edit-region-name" size="md"-->
<!--                                               [isAsync]="true"-->
<!--                                               (trigger)="updateCustomPlaceBtnName($event, place, i)">save-->
<!--                                    </ig-button>-->
<!--                                    <ig-button class="edit-region-name" size="md" color="cancel"-->
<!--                                               (trigger)="isEditPlaceDisplayTitle[i]=false">cancel-->
<!--                                    </ig-button>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <p class="add-new-tab" (click)="addNewAndSavePlace()">-->
<!--                                <mat-icon>add</mat-icon>-->
<!--                                Add a new custom place button-->
<!--                            </p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--        </mat-tab>-->
<!--        <mat-tab>-->
<!--            <ng-template mat-tab-label>-->
<!--                <mat-icon>image</mat-icon>-->
<!--                Promotions-->
<!--            </ng-template>-->
<!--            <div class="panel">-->
<!--                <div class="panel-header">-->
<!--                    <h1>Visitor Promotion Image</h1>-->
<!--                </div>-->

<!--                <div class="flex">-->
<!--                    <div class="m-r-1">-->
<!--                        <mat-radio-group class="radio-group" [(ngModel)]="visitorPromotionImage.isDisabled">-->
<!--                            <mat-radio-button [value]="false">-->
<!--                                Turn On Promotion Image-->
<!--                            </mat-radio-button>-->
<!--                            <mat-radio-button [value]="true">-->
<!--                                Turn Off Promotion Image-->
<!--                            </mat-radio-button>-->
<!--                        </mat-radio-group>-->

<!--                        <div class="m-t-3" *ngIf="!visitorPromotionImage.isDisabled">-->
<!--                            <ig-field label="Link"-->
<!--                                      [(ngModel)]="visitorPromotionImage.link"-->
<!--                                      [formControl]="promotionForm.get('link')">-->
<!--                            </ig-field>-->

<!--                            <div class="m-t-3">Position (only enable on side bar mode)</div>-->
<!--                            <div class="group">-->
<!--                                <mat-radio-group [formControl]="promotionForm.get('isTop')" class="radio-group"-->
<!--                                                 [(ngModel)]="visitorPromotionImageCommand.isTop">-->
<!--                                    <mat-radio-button [value]="false">-->
<!--                                        Bottom-->
<!--                                    </mat-radio-button>-->
<!--                                    <mat-radio-button [value]="true">-->
<!--                                        Top-->
<!--                                    </mat-radio-button>-->
<!--                                </mat-radio-group>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <ig-button (trigger)="savePromotion($event)" size="md" [isAsync]="true">Save</ig-button>-->

<!--                    </div>-->

<!--                    <div class="m-l-1" *ngIf="!visitorPromotionImage.isDisabled">-->
<!--                        <ig-image-selector [command]="visitorPromotionImageCommand"-->
<!--                                           [selectedImageData]="visitorPromotionImage.image">-->
<!--                        </ig-image-selector>-->
<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->
<!--        </mat-tab>-->
<!--    </mat-tab-group>-->
<!--</div>-->


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/customization/marketing/marketing.component.html